import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { InstallPwaComponent } from './components/install-pwa/install-pwa.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    DialogModule
  ],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss'
})
export class App {
  
  deferredPrompt:any;
  private installDialogShown = false;
  dialog: Dialog = inject(Dialog);
  
  constructor(){
    //add a history state to prevent close application on back naviagation
    history.pushState(null, '');

    // ANDROID/CHROME/EDGE
    window.addEventListener('beforeinstallprompt', (event: Event) => {
      event.preventDefault();
      this.deferredPrompt = event;
      if (this.installDialogShown) {
        return;
      }
      this.installDialogShown = true;

      const dialogRef = this.dialog.open(InstallPwaComponent, {
        data: {
          title: 'pwa-install-dialog.alert_title',
          message: 'pwa-install-dialog.alert_message',
          platform: 'google'
        },
      });
  
      dialogRef.closed.subscribe(async (result:any)  => {
        if(result?.action === 'continue' && this.deferredPrompt){
          this.deferredPrompt.prompt();
          const { outcome } = await this.deferredPrompt.userChoice;
          this.deferredPrompt = null;
        }
      }); 

    });

    // IOS/SAFARI
    console.log(window.navigator.userAgent);
    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    const isInStandalone = (window.navigator as any).standalone === true 
      || window.matchMedia('(display-mode: standalone)').matches;

    if (isIos && !isInStandalone) {
      setTimeout(() => {
        this.dialog.open(InstallPwaComponent, {
          data: { 
            title: 'pwa-install-dialog.alert_title',
            message: 'pwa-install-dialog.alert_message',
            platform: 'apple' 
          }
        });
      }, 1500);
    }

    // Detecta quando o app volta do background
    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        
        const originalState = JSON.stringify({
          psychologist_connection : true,
          notifications: true
        });

        localStorage.setItem('originalState', originalState);
      }
    });

  }

}
